import React from "react";
import * as S from "./ModalVisualisacaoCaixinhaStyle";
import { formatNumber, formatDateSystem } from "../../../assets/utils";
import {
  FaTimes,
  FaMoneyBillWave,
  FaCalendarAlt,
  FaFileContract,
  FaClock,
} from "react-icons/fa";

export default function ModalVisualisacaoCaixinha({ isOpen, onClose, data }) {
  if (!isOpen || !data) return null;

  const isMonthly = data.goldenBoxOptionId === 1;
  const modalidadeLabel = isMonthly ? "Fim + 1.3% Mensal" : "Anual + 12% Bônus";

  console.log(data)

  const getStatusInfo = (status) => {
    const statusStr = status ? status.toUpperCase() : "";
    switch (statusStr) {
      case "PENDING":
        return { label: "PENDENTE", color: "#f59e0b" };
      case "ACTIVE":
        return { label: "ATIVO", color: "#10b981" };
      case "FINISHED":
        return { label: "FINALIZADO", color: "#3b82f6" };
      case "REJECTED":
        return { label: "REJEITADO", color: "#ef4444" };
      case "CANCELED":
        return { label: "CANCELADO", color: "#ef4444" };
      default:
        return { label: "DESCONHECIDO", color: "#6b7280" };
    }
  };

  const { label: statusLabel, color: statusColor } = getStatusInfo(data.status);

  // Verificação de segurança para as datas
  const sortedDates =
    data.nextWithdrawDates?.map((d) => new Date(d)).sort((a, b) => a - b) || [];

  const getDateStatus = (dateObj) => {
    const now = new Date();
    // Usa try-catch para evitar erro em ambientes sem suporte a timeZone
    let todayBRT;
    try {
      const brtDateString = now.toLocaleString("en-US", {
        timeZone: "America/Sao_Paulo",
      });
      todayBRT = new Date(brtDateString);
    } catch (e) {
      todayBRT = new Date(); // Fallback para hora local se falhar
    }

    todayBRT.setHours(0, 0, 0, 0);

    const yesterdayBRT = new Date(todayBRT);
    yesterdayBRT.setDate(todayBRT.getDate() - 1);

    const checkDate = new Date(dateObj);
    checkDate.setHours(0, 0, 0, 0);

    const tCheck = checkDate.getTime();
    const tToday = todayBRT.getTime();
    const tYesterday = yesterdayBRT.getTime();

    if (tCheck === tToday || tCheck === tYesterday) return "active";
    if (tCheck < tYesterday) return "passed";
    return "future";
  };

  // --- VALORES SEGUROS ---
  const contractId = data.contractId || "N/A";
  const contractTotalPrice = data.contract?.totalPrice
    ? `R$ ${formatNumber(data.contract.totalPrice)}`
    : "Pendente aprovação";

  const totalAccumulated =
    data.totalAccumulated != null
      ? `R$ ${formatNumber(data.totalAccumulated)}`
      : "Pendente aprovação";

  const currentAmountAvaliable =
    data.currentAmountAvaliable != null
      ? `R$ ${formatNumber(data.currentAmountAvaliable)}`
      : "Pendente aprovação";

  const creationDate = data.dateCreated
    ? formatDateSystem(data.dateCreated)
    : "N/A";

  const activationDate = data.activationDate
    ? formatDateSystem(data.activationDate)
    : "Aguardando ativação";

  const monthlyBonus =
    data.monthlyBonus != null
      ? `${formatNumber(data.monthlyBonus)}%`
      : "Pendente aprovação";

    const currentBonus =
      data.currentBonus != null
        ? `${formatNumber(data.currentBonus)}%`
        : "Pendente aprovação";

  const finalBonus =
    data.finalBonus != null
      ? `${formatNumber(data.finalBonus)}%`
      : "Pendente aprovação"; // Ou apenas "-" se não tiver

  const totalCurrentAccumulated =
    data.totalCurrentAccumulated != null
      ? `R$ ${formatNumber(data.totalCurrentAccumulated)}`
      : "Pendente aprovação";

  const finalIncome =
    data.FinalIncome != null
      ? `R$ ${formatNumber(data.FinalIncome)}`
      : "Pendente aprovação";

  return (
    <S.Overlay onClick={onClose}>
      <S.Container onClick={(e) => e.stopPropagation()}>
        <S.Header>
          <div className="title-group">
            <FaFileContract />
            <h2>Detalhes da Aplicação</h2>
          </div>
          <button onClick={onClose}>
            <FaTimes />
          </button>
        </S.Header>

        <S.Body>
          <S.InfoSection>
            <div className="top-row">
              <S.Badge type={isMonthly ? "monthly" : "annual"}>
                {modalidadeLabel}
              </S.Badge>
              <S.StatusBadge color={statusColor}>{statusLabel}</S.StatusBadge>
            </div>
            <div className="contract-id">
              <label>Contrato Vinculado - Valor Contrato</label>
              <h1>
                #{contractId} - {contractTotalPrice}
              </h1>
            </div>
          </S.InfoSection>

          <S.GridFinanceiro>
            <S.CardValue>
              <div className="icon-box">
                <FaMoneyBillWave />
              </div>
              <div>
                <label>Saldo Acumulado Total</label>
                <h3>{totalAccumulated}</h3>
              </div>
            </S.CardValue>

            <S.CardValue highlight>
              <div className="icon-box">
                <FaClock />
              </div>
              <div>
                <label>Disponível para Saque</label>
                <h3>{currentAmountAvaliable}</h3>
              </div>
            </S.CardValue>
          </S.GridFinanceiro>

          <S.DetailList>
            <S.DetailItem>
              <span>Data de Criação</span>
              <strong>{creationDate}</strong>
            </S.DetailItem>
            <S.DetailItem>
              <span>Data de Ativação</span>
              <strong>{activationDate}</strong>
            </S.DetailItem>
            <S.DetailItem>
              <span>Bônus Mensal Configurado</span>
              <strong>{monthlyBonus}</strong>
            </S.DetailItem>
            <S.DetailItem>
              <span>Bônus Atual</span>
              <strong>{currentBonus}</strong>
            </S.DetailItem>
            {/* Exibe Bonus Final apenas se existir (ex: modalidade anual) */}
            {data.finalBonus > 0 && (
              <S.DetailItem>
                <span>Bônus Final</span>
                <strong>{finalBonus}</strong>
              </S.DetailItem>
            )}
            <S.DetailItem>
              <span>Total Atual Acumulado (valorização)</span>
              <strong>{totalCurrentAccumulated}</strong>
            </S.DetailItem>
            <S.DetailItem>
              <span>Total Final (Valorização Acumulada + Bônus)</span>
              <strong>{finalIncome}</strong>
            </S.DetailItem>
          </S.DetailList>

          <S.SectionTitle>
            <FaCalendarAlt /> Calendário de Saques
          </S.SectionTitle>

          <S.DatesContainer>
            {sortedDates.length > 0 ? (
              sortedDates.map((date, index) => {
                const status = getDateStatus(date);
                return (
                  <S.DateChip key={index} status={status}>
                    {date.toLocaleDateString("pt-BR")}
                  </S.DateChip>
                );
              })
            ) : (
              <p className="empty-msg">
                Não há saques previstos ou aguardando aprovação.
              </p>
            )}
          </S.DatesContainer>
        </S.Body>

        <S.Footer>
          <button onClick={onClose}>FECHAR</button>
        </S.Footer>
      </S.Container>
    </S.Overlay>
  );
}
